module.exports = __webpack_public_path__ + "static/img/2.a029e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/1/2.png
// module id = tp+L
// module chunks = 0